import React, { useContext } from 'react'
import '../../src/assets/AdminCss/card.css'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthContext, base_url } from '../context/Authcontext';
import axios from 'axios';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useEffect } from 'react';
import { useState } from 'react';
import LoginReg from './LoginReg';

const TurboAll = () => {
    const navigate= useNavigate();
    const { userdata } = useContext(AuthContext);
    const [isSidebar, setSidebar] = useState(false);
    const [active, setActive]=useState(false);
    const allGames=[
        { src: "/Turbo_games/magic_keno.jpg", name: "Magic Keno",GAMEID:'keno' ,provider:'turbo'},
    { src: "/Turbo_games/mines.jpg", name: "Mines",GAMEID: 'mines',provider:'turbo'},
    { src: "/Turbo_games/multiplayer_mines.jpg", name: "Multiplayer Mines",GAMEID:'multiplayermines',provider:'turbo' },
    { src: "/Turbo_games/neko.jpg", name: "Neko",GAMEID: 'neko',provider:'turbo'},
    { src: "/Turbo_games/pumped.jpg", name: "PumpedX",GAMEID:'pumpedx',provider:'turbo'},
    { src: "/Turbo_games/save_the_princes.jpg", name: "Save the Princess",GAMEID:'stp',provider:'turbo'},
    { src: "/Turbo_games/spine_strike.jpg", name: "Spin Strike",GAMEID:'spinstrike',provider:'turbo' },
    { src: "/Turbo_games/take_my_plinko.jpg", name: "Take My Plinko",GAMEID:'takemyplinko',provider:'turbo'},
    { src: "/Turbo_games/turbo_mines.jpg", name: "Turbo Mines",GAMEID:'turbomines',provider:'turbo'},
    { src: "/Turbo_games/turbo_plinko.jpg", name: "Turbo Plinko",GAMEID:'takemyplinko',provider:'turbo' },
    { src: "/Turbo_games/vortex.jpg", name: "Vortex",GAMEID:'vortex',provider:'turbo' },
    { src: "/Turbo_games/wicket_blast.jpg", name: "Wicket Blast",GAMEID:'wicketblast',provider:'turbo' },
    { src: "/Turbo_games/oneTapMines.jpg", name: "1Tap Mines",GAMEID:'1tapmines',provider:'turbo' },
    { src: "/Turbo_games/aero.jpg", name: "Aero",GAMEID: 'aero',provider:'turbo'},
    { src: "/Turbo_games/ball_ball.jpg", name: "Ball & Ball",GAMEID: 'ballandball',provider:'turbo'},
    { src: "/Turbo_games/baypaktar.jpg", name: "Bayraktar",GAMEID:'bayraktar',provider:'turbo' },
    { src: "/Turbo_games/book_of_mines.jpg", name: "Book of Mines",GAMEID:'bookofmines',provider:'turbo' },
    { src: "/Turbo_games/bubbles.jpg", name: "Bubbles",GAMEID:'bubbles',provider:'turbo' },
    { src: "/Turbo_games/dog_street.jpg", name: "Dogs' Street",GAMEID:'dogstreet',provider:'turbo' },
    { src: "/Turbo_games/donny_king.jpg", name: "Donny King",GAMEID: 'donnyking',provider:'turbo'},
    { src: "/Turbo_games/double_roll.jpg", name: "Double Roll",GAMEID: 'double',provider:'turbo'},
    { src: "/Turbo_games/fast_fielder.jpg", name: "Fast Fielder",GAMEID:'fastfielder',provider:'turbo' },
    { src: "/Turbo_games/fruit_towers.jpg", name: "Fruit Towers",GAMEID:'fruittowers',provider:'turbo' },
    { src: "/Turbo_games/fury_stairs.jpg", name: "Fury Stairs",GAMEID: 'stairs',provider:'turbo'},
    { src: "/Turbo_games/hamsta.jpg", name: "Hamsta",GAMEID:'hamsta',provider:'turbo' },
    { src: "/Turbo_games/hilo.jpg", name: "Hi-Lo",GAMEID:'hilo',provider:'turbo' },
    { src: "/Turbo_games/javelinx.jpg", name: "Javelinx",GAMEID:'javelinx',provider:'turbo' },
    { src: "/Turbo_games/jewel_clicker.jpg", name: "Jewel Clicker",GAMEID: 'jewelclicker',provider:'turbo'},
    { src: "/Turbo_games/Limbo_rider.jpg", name: "Limbo Rider",GAMEID: 'limbo',provider:'turbo'},
    { src: "/Turbo_games/crashx.jpg", name: "Crash X",GAMEID:'crash',provider:'turbo' },
    { src: "/Turbo_games/crash2.jpg", name: "Crash X Football Edition",GAMEID:'crashfootball',provider:'turbo'},
    { src: "/Turbo_games/dice_thrice.jpg", name: "Dice Thrice",GAMEID:'dicethrice',provider:'turbo' },
    { src: "/Turbo_games/dice_twice.jpg", name: "Dice Twice",GAMEID:'dice',provider:'turbo' }
    ];

      const openGameById = async (slider) => {
        console.log("slide", slider);
    
        userdata(async (res) => {
          if (res?.status) {
            
            if (slider.provider === "turbo") {
                const fetchLink= async()=> {
                    const gameUrl = `https://${slider.GAMEID}.turbogames.io/`;

                    return gameUrl;
                }
            
    
              toast.promise(
                fetchLink().then((gameUrl) => {
                  navigate("/lobby", { state: gameUrl }, { replace: true });
                }),
                {
                  loading: "Generating game link...",
                  success: "Game link generated!",
                  error: "Error generating game link.",
                }
              );
            }
          } else {
            setActive(true);
            toast.error("Please Login To Play!");
          }
        });
      };

      useEffect(() => {
        window.scrollTo(0,0);
          const handleResize = () => {
            if (window.innerWidth > 991) {
              setSidebar(true);
            } else {
              setSidebar(false);
            }
          };
      
          // Add event listener for resize
          window.addEventListener("resize", handleResize);
      
          // Initial check to set the correct sidebar state
          handleResize();
      
          // Cleanup the event listener on component unmount
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);

    return (
      <>
    {<LoginReg active={active} setactive={setActive}/>}
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
            <div _ngcontent-jrx-c101="">
              <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
                <div _ngcontent-jrx-c95="" className="head-container">
                  <div _ngcontent-jrx-c95="" className="body-container">
                    <Sidebar isSidebar={isSidebar} />
                    <div
                      _ngcontent-jrx-c95=""
                      className={`rightbar`}
                      style={{
                        width: isSidebar ? '' : "1500%",
                        transition: "width 0.3s ease-in-out",
                      }}
                    >
                      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      
                  <h1 className='pl-5 text-yellow fs-2'>Turbo Games</h1>
      
                  <div className="d-flex flex-wrap justify-content-center gp">
                      {allGames?.map((game, index) => (
                          <div key={index} className="rounded-4 p-3 text-center" style={{ width: "19rem", boxShadow: "0px 5px 15px rgba(255, 242, 140, 0.4)" }}>
                          <img
                              src={game.src}
                              alt="jili games"
                             
                              style={{ width: "100%", height: "250px", objectFit: "cover" }}
                          />
                          <p className="text-white mt-2">{game.name}</p>
                          <button className="btn btn-info w-100 container" onClick={() => openGameById(game)}>
                              Play
                          </button>
                          </div>
                      ))}
                  </div>
                      
                    </div>
                  </div>
                </div>
              </app-landing-page-new>
            </div>
          </app-root>
</>
    )
}

export default TurboAll
